import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0effa317"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lds-facebook" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]


export default /*#__PURE__*/_defineComponent({
  __name: 'SpinnerBar',
  props: {
		height_: {
			type: String,
			default: "40px",
		},
		width_: {
			type: String,
			default: "40px",
		},
		height: {
			type: String,
			default: "34px",
		},
		width: {
			type: String,
			default: "34px",
		},
		color: {
			type: String,
			default: "rgb(255, 255, 255)",
		},
	},
  setup(__props) {

_useCssVars(_ctx => ({
  "44289048": (__props.width_),
  "810a1016": (__props.height_),
  "2830e4e3": (__props.width)
}))

	

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
}
}

})